
const downloadFileString = (fileString:string, filename:string) => {
    var blob = new Blob([fileString], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}
const downloadTemplate = () => {
    const template = "GROUP NAME,RECIPIENTS,LOOKUP MACRO,LOOKUP KEY"
    const filename = "reports_maker_recipient_import_template.csv"

    downloadFileString(template, filename)
}

export { downloadTemplate, downloadFileString}